/// <reference path="global.d.ts" />

export function generatePDFUrl(action: PDFAction, entryIDs: number[], layoutId = 'default', preview = false): string {
    let params = entryIDs.map(id => `entry_ids[]=${id}`).join('&');
    if (preview) {
        params = `${params}&preview=true`;
    }
    return `${PDFGenerator.ajax_url}?action=pdf_action&action_key=${action.key}&${params}&pdf_layout=${layoutId}`;
}

export async function triggerDownload(downloadUrl: string): Promise<boolean> {

        const request = await fetch(downloadUrl);
        if (!request.ok) {
            throw new Error('Failed to download PDF');
        }
        console.log(request);

        const blob = await request.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = '';
        a.click();
        return true;
}